import { CheckCircle2, Download, RotateCcw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useI18n } from '@/lib/i18n'
import { formatBytes } from '@/lib/format'

interface ResultCardProps {
  fileName: string
  sizeBytes: number
  onDownload: () => void
  onReset: () => void
}

/** Success state: downloadable result summary. */
export function ResultCard({ fileName, sizeBytes, onDownload, onReset }: ResultCardProps) {
  const { t } = useI18n()

  return (
    <div className="rounded-xl border bg-card p-6 shadow-sm">
      <div className="flex items-center gap-2">
        <CheckCircle2 className="h-5 w-5 text-primary" aria-hidden />
        <p className="font-medium">{t('resultDone')}</p>
      </div>

      <div className="mt-4 flex items-center justify-between rounded-lg bg-muted px-4 py-3">
        <p className="truncate text-sm font-medium">{fileName}</p>
        <p className="ml-3 shrink-0 font-mono text-xs text-muted-foreground">
          {formatBytes(sizeBytes)}
        </p>
      </div>

      <div className="mt-4 flex flex-col gap-2 sm:flex-row">
        <Button onClick={onDownload} className="flex-1">
          <Download className="mr-1" aria-hidden />
          {t('commonDownload')}
        </Button>
        <Button variant="outline" onClick={onReset} className="flex-1">
          <RotateCcw className="mr-1" aria-hidden />
          {t('commonNewFile')}
        </Button>
      </div>
    </div>
  )
}
